import React, { Component } from 'react';
import { TextField, InputAdornment,Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Box, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
//import axios from 'axios';
import AddIcon from '@mui/icons-material/Add';
import { Navigate  } from 'react-router-dom';
import Serverurl from './Apiurl';
import searchIcon from './images/SEARCH.png';
import axiosInstance from "./axiosConfig";

export default class BlogList extends Component {
  state = {
    blogs: [],
    totalItems: 0,titleFilter: "",
    page: 0,
    rowsPerPage: 5,
    itemsPerPageOptions: [5, 10, 20],
  };

  componentDidMount() {
	   document.title = "Prep for Sale- Staff Management";
		if(localStorage.getItem("DCuserid")==null)
		  {
		   this.setState({
            logredirect: true,
			pagename:'/'
          })
		  }
    this.fetchBlogs();
  }

fetchBlogs = () => {
  const { page, rowsPerPage, titleFilter } = this.state;

  axiosInstance.get(`${Serverurl}blog/bloggetall`, {
    params: {
      page,
      limit: rowsPerPage,
      title: titleFilter    
    }
  })
  .then(res => {
    const { data, totalItems } = res.data;
    this.setState({ blogs: data, totalItems });
  })
  .catch(() => alert(''));
};

  handleDelete = (bl_id) => {
    confirmAlert({
      title: 'Confirm Delete',
      message: 'Are you sure you want to delete this blog?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => axiosInstance.delete(`${Serverurl}blog/blogdelete/${bl_id}`)
            .then(this.fetchBlogs)
            .catch(() => alert('Failed to delete blog.'))
        },
        { label: 'No' }
      ]
    });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, this.fetchBlogs);
  };

  handleChangeRowsPerPage = (event) => {
    const newRows = parseInt(event.target.value, 10);
    this.setState({ rowsPerPage: newRows, page: 0 }, this.fetchBlogs);
  };
handleSearch = () => {
  this.setState({ page: 0 }, this.fetchBlogs);
};

  render() {
 if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    } 

    return (
       <div className="maincontentDiv">
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>		
          <Typography className="contentHeading" variant="h5">Blog Management</Typography>
          <NavLink to="/AddBlog">
            <Button 
			size="small"
			style={{
    marginRight: '20px',
    marginTop: '15px'
}}
			variant="contained" className="frmPrimarybtn"
			startIcon={<AddIcon />}>Add</Button>
          </NavLink>
        </Box>
<Box 
  className="contentSearch" 
  sx={{ display: "flex", gap: 2, alignItems: "flex-end", mb: 3 }}
>
  <Box sx={{ mb:2,display: "flex", flexDirection: "column", width: "230px" }}>
    <Typography variant="body1">Title</Typography>

    <TextField
      placeholder="Search"
      value={this.state.titleFilter}
      onChange={e => this.setState({ titleFilter: e.target.value })}
      size="small"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <img src={searchIcon} alt="Search" />
          </InputAdornment>
        ),
      }}
    />
  </Box>

  <Button
    sx={{ mb:2 }}
    size="small"
    variant="contained"
    className="frmPrimarybtn"
    onClick={this.handleSearch}
  >
    Search
  </Button>
</Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Title</TableCell>
                <TableCell>Description</TableCell>
				{/* <TableCell>Images</TableCell>*/}
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
{this.state.blogs.length === 0 ? (
  <TableRow>
    <TableCell colSpan={3} align="center" style={{ padding: "20px" }}>
      No records found
    </TableCell>
  </TableRow>
) : (
  this.state.blogs.map(blog => (
    <TableRow key={blog.bl_id}>
 <TableCell>{blog.bl_title}</TableCell>
     <TableCell>
        <div
          dangerouslySetInnerHTML={{
            __html: blog.bl_description.slice(0, 100) + '...',
          }}
        />
      </TableCell>
      <TableCell>
        <NavLink to={`/AddBlog?id=${blog.bl_id}`}>
          <Button 
            size="small"
            variant="contained"
            className="frmPrimarybtn"
            endIcon={<EditIcon />}
            sx={{ mr: 1 }}
          >
            Edit
          </Button>
        </NavLink>

        <Button
          size="small"
          variant="contained"
          className="frmSecondarybtn"
          onClick={() => this.handleDelete(blog.bl_id)}
          endIcon={<DeleteIcon />}
        >
          Delete
        </Button>
      </TableCell>
    </TableRow>
  ))
)}
            </TableBody>
          </Table>

          <TablePagination
            component="div"
            count={this.state.totalItems}
            page={this.state.page}
            onPageChange={this.handleChangePage}
            rowsPerPage={this.state.rowsPerPage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
            rowsPerPageOptions={this.state.itemsPerPageOptions}
          />
        </TableContainer>
      </div>
    );
  }
}
